<template lang='html'>
  <div class="app-card mb-0">

    <!-- <v-btn color="success" @click.stop="add_item">Add</v-btn>
    <v-btn color="success" @click.stop="set_vip">VIP</v-btn> -->

    <div class="app-card-content">
        <v-data-table
          :headers="headers"
          :items="list"
          item-key="gid"
          hide-actions
          no-data-text='无商品信息'
          class="elevation-1"
        >
        <template slot="headers" slot-scope="props">
          <tr>
            <th style="width: 20px;">
              <!-- @click.native="toggleAll"
                :input-value="props.all" -->
              <v-checkbox
                primary
                hide-details
                v-model="select_all"
              ></v-checkbox>
            </th>
            <th v-for="header in props.headers" :key="header.text">
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td>
              <v-checkbox
                primary
                hide-details
                v-model="props.item.selected"
              ></v-checkbox>
          </td>
          <td>
            <v-btn fab dark small color="pink darken-1" @click='delete_it(props.item)'>
              <v-icon dark class="iconfont">icon-del1</v-icon>
            </v-btn>
          </td>
          <td>
              <h3>{{ props.item.name }}
                <span v-if="props.item.isEMS" class="mylable purple darken-1">直邮</span>
              </h3>
              <p>
                {{ props.item.gid }}
                <span v-if="props.item.save_take == 'take'" class="mylable red darken-1" >存{{props.item.all_num}}&提货</span>
              </p>
          </td>
          <td class="text-xs-left">
            <h4>{{props.item.sale_price}}</h4>
            <span class="mylable mylable-success ">V:{{props.item.default_vip_price}}</span>
          </td>
          <td class="text-xs-left">
            <span class='realprice'>{{props.item.real_price.toFixed(2)}}</span>
            <span class="mylable mylable-success " v-if="props.item.default_vip_price == props.item.real_price">V</span>
            <span class="mylable purple darken-1">{{item_discount(props.item.gid)}}折</span>
            <v-badge color="pink" v-if="Math.floor(props.item.less/props.item.real_price)>0">
              <span slot="badge">{{Math.floor(props.item.less/props.item.real_price)}}</span>
              <span class="p_less" >赠</span>
            </v-badge>
          </td>
          <td class="text-xs-left">
            <v-btn fab dark small color="warning" @click='inc_number(props.item,-1)'>
              <v-icon dark class="iconfont">icon-jian</v-icon>
            </v-btn>

             <span class='p_count'>{{props.item.num}}</span>
            <v-btn fab dark small color="success" @click='inc_number(props.item,+1)'>
              <v-icon dark class="iconfont">icon-plus</v-icon>
            </v-btn>

          </td>
          <td class="text-xs-center`">
              <opermenu :item= "props.item" :isfinished="isfinished"></opermenu>  
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { mapGetters,mapMutations } from 'vuex'
import opermenu   from './oper_menu'

let g_index = 0;

export default {
    //template:``,
    name: '',
    props:{
      // isfinished:{type:Boolean, default:false }
    },
    // mixins:[oper_mixin],
    computed:{
      ...mapGetters({
        vip_info      :'vip_info',
        list          :'get_prodcuts_list',//商品列表
        item_money    :'get_product_money',//单品总金额
        item_discount :'get_product_discount',//单品折扣
        pay_info      :'get_pay_info',
        prepay_money  :'get_use_prepay_money',
      }),
      isfinished(){
        return this.pay_info.pay_status;
      }
    },
    methods:{
      ...mapMutations({
        edit_item:'PRODUCTS_EDIT_ITEM',
        select_all_rec:'PRODUCTS_SELECT_ALL'
      }),
      msgpad_show(group,title,text,type){
        this.$notify({ group, title, text, type})
      },

      delete_it(item){
        if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
          this.$store.commit('VIP_PREPAY_MONEY_ADJUST',this.prepay_money);
          this.$store.commit('USE_PREPAY_MONEY', 0.0)
          this.$store.commit('PRODUCTS_EDIT_ITEM',{
              gid:item.gid,
              oper:'delete'
          })
      },
      inc_number(item,val){
          if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
          this.$store.commit('VIP_PREPAY_MONEY_ADJUST',this.prepay_money);
          this.$store.commit('USE_PREPAY_MONEY', 0.0)
          this.$store.commit('PRODUCTS_EDIT_ITEM',{
              gid:item.gid,
              oper:'inc_num',
              value:val
          })
      },
      inc_save(item,val){
          if(this.isfinished) {this.msgpad_show("msgpad","ERROR",'本单已经结算','error');return};
           this.$store.commit('PRODUCTS_EDIT_ITEM',{
              gid:item.gid,
              oper:'inc_save',
              value:val
          })
      },
    },
    components:{opermenu},
    watch:{
      select_all(val){
          this.select_all_rec(val);
      }
    },
    directives: {},
    mounted :function(){},
    data () {
      return {
        select_all:false,
        headers: [
          { text : '',sort:false },
          { text : '商品名称'  , value: 'name' },
          { text : '零售价'   , value:'sale_price' },
          { text : '折扣价'   , value: 'real_price' },
          { text : '数量'     , value: 'num' },
          { text : '金额'   , value: 'protein' }
        ],
        /*{
    "gid": "8801092512721",
    "nm": "保宁洗衣香皂(香草香）",
    "num": 1,
    "price": 14,
    "realprice": 14,
    "discount": 100,
    "money": 14,
    "less": 0,
    "save_num": 0,
    "flag": "sale",
    "isEMS": false,
    "outsea": false
  }*/
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.realprice{
  font-size: 2.0em;
}
.p_count{
  font-size: 25px;
  font-weight: bold;
  color: #a94442;
}

.mylable.mylable-purple{
    background-color: #9585bf;
}

.mylable.mylable-success{
    background-color: #82af6f;
}
.mylable {
    border-radius: 0;
    text-shadow: none;
    font-weight: normal;
    color: #ffffff;
    font-size: 16px;
    line-height: 1.15;
    height: 20px;
    display: inline-block;
    padding: 0 4px ;
    margin-right: 4px;
}



</style>



// WEBPACK FOOTER //
// src/views/front_sale/components/product_item_table.vue